import { cn } from '@lib/utils';
import React from 'react';

import styles from './CountPill.module.scss';

interface CountPillProps {
  count: number;
  variant?: 'accent' | 'neutral';
  className?: string;
}

export const CountPill: React.FC<CountPillProps> = ({ count, variant = 'accent', className }) => (
  <span className={cn(styles.pill, styles[variant], className)}>{count}</span>
);
